// app.config.ts
import {
  ApplicationConfig,
  provideZoneChangeDetection,
  provideAppInitializer,
  inject,
} from '@angular/core';
import { provideRouter } from '@angular/router';

import { CustomAppConfig } from './custom.app.config';
import { routes } from '../app.routes';
import {
  provideHttpClient,
  withFetch,
  withInterceptors,
} from '@angular/common/http';
import { AuthenticationInterceptor } from '../libs/core/src/lib/interceptors/auth.interceptor';
import { AuthGuard } from 'app/libs/core/src/lib/guards/auth.guard';
import { ParentService } from 'app/services/parent.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(
      withFetch(),
      withInterceptors([AuthenticationInterceptor])
    ),
    ParentService,
    CustomAppConfig,

    provideAppInitializer(() => {
      const config = inject(CustomAppConfig);

      return config.load();
    }),
    AuthGuard,
  ],
};
